import _ from 'underscore';

const utility = {};

utility.isObject = (element) => typeof element === 'object' && element !== null;
utility.addClass = (element, aClass = '') => {
  if (!utility.hasClass(element, aClass)) {
    element.classList.add(aClass);
  }
  return element.classList;
};
utility.addAndRemoveClasses = (element, addAClass, removeAClass) => {
  element.classList = utility.addClass(element, addAClass);
  element.classList = utility.removeClass(element, removeAClass);
  return element.classList;
};
utility.hasClass = (element, aClass) => utility.isObject(element) && element.classList && element.classList.contains(aClass);
utility.removeClass = (element, aClass = '') => {
  if (utility.hasClass(element, aClass)) {
    element.classList.remove(aClass);
    return element.classList;
  }
  if (utility.isObject(element)) {
    return element.classList;
  }
  return element;
};
utility.toggleClass = (element, aClass = '', bClass = '') => {
  if (bClass === '') {
    element.classList.toggle(aClass);
  } else if (utility.hasClass(element, aClass)) {
    element.classList = utility.addAndRemoveClasses(element, bClass, aClass);
  } else if (utility.hasClass(element, bClass)) {
    element.classList = utility.addAndRemoveClasses(element, aClass, bClass);
  }
  return element.classList;
};
utility.show = (element) => utility.addAndRemoveClasses(element, 'menu-show', 'menu-hidden');
utility.hide = (element) => utility.addAndRemoveClasses(element, 'menu-hidden', 'menu-show');
utility.removeListOfClasses = (dClasses = []) => {
  if (dClasses === null || dClasses === undefined || dClasses.length <= 0) { return false; }
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const aClass in dClasses) {
    while (document.querySelector(`.${dClasses[aClass]}`)) {
      utility.removeClass(document.querySelector(`.${dClasses[aClass]}`), dClasses[aClass]);
    }
  }
  return true;
};
utility.addClasses = (searchForClass, dClass = '') => {
  if (dClass === null || dClass === undefined || dClass.length === '') { return false; }
  const allWithClass = document.querySelectorAll(searchForClass);
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (let i = 0; i < allWithClass.length; i++) {
    allWithClass[i].classList.add(dClass);
  }

  return true;
};
utility.getTop = (element) => utility.elementRect(element).top;
utility.getWidth = (element) => utility.elementRect(element).width;
utility.getHeight = (element) => utility.elementRect(element).height;
utility.elementRect = (element) => element.getBoundingClientRect();// width,  height,  top,  bottom,  left,  right
utility.slideToggle = (element, isSlideOpen = true, isHeightChecked = false, initialHeight = 0, intValue = null) => {
  window.clearInterval(intValue);
  let initHeight = initialHeight;
  let heightChecked = isHeightChecked;
  let slideOpen = isSlideOpen;
  let intVal = intValue;
  if (!heightChecked) {
    initHeight = element.offsetHeight;
    heightChecked = true;
  }
  if (slideOpen) {
    let h = initHeight;
    slideOpen = false;
    intVal = setInterval(() => {
      h--;
      element.style.height = `${h}px`;
      if (h <= 0) window.clearInterval(intVal);
    }, 1);
  } else {
    let h = 0;
    slideOpen = true;
    intVal = setInterval(() => {
      h++;
      element.style.height = `${h}px`;
      if (h >= initHeight) window.clearInterval(intVal);
    }, 1);
  }
};
utility.windowWidth = document.body.clientWidth;
utility.notNullOrUndefined = (element) => element !== null && element !== undefined;
utility.windowHeight = document.body.clientHeight;
utility.scrollToTop = window.scrollY;
utility.possibleId = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
utility.getSelectorIdentifier = (element) => {
  if (utility.notNullOrUndefined(element.getAttribute('id'))) { return `#${element.getAttribute('id')}`; }
  if (utility.notNullOrUndefined(element.className)) { return `.${element.className.toString().trim().replace(/\./g, ' ')}`; }
  return element;
};
utility.createNode = (tagName, attributes = {}, aText = '') => {
  const newNode = document.createElement(tagName);
  if (aText !== '') {
    newNode.appendChild(document.createTextNode(aText));
  }
  if (attributes !== {}) {
    // eslint-disable-next-line guard-for-in,no-restricted-syntax
    for (const key in attributes) {
      newNode.setAttribute(key, attributes[key]);
    }
  }
  if (!newNode.hasAttribute('id')) {
    newNode.setAttribute('id', utility.makeid());
  }
  return newNode;
};
utility.findParent = (startElement, tagName) => {
  let currentElm = startElement;
  while (currentElm !== document.body) {
    if (currentElm.tagName.toLowerCase() === tagName.toLowerCase()) {
      return currentElm;
    }
    currentElm = currentElm.parentElement;
  }
  return false;
};
utility.css = (element, cssObject = {}) => {
  if (!utility.isObject(element)) {
    return element;
  }
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const property in cssObject) {
    element.style.setProperty(property, cssObject[property]);
  }
  return element.style;
};
utility.addEvent = (obj, evt, fn) => {
  if (obj.addEventListener) {
    obj.addEventListener(evt, fn, false);
  } else if (obj.attachEvent) {
    obj.attachEvent(`on${evt}`, fn);
  }
};

utility.capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

utility.debounce = (func) => {
  let timer;
  return (event) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(func, 100, event);
  };
};

utility.flattenMessages = (originals, blacklist) => {
  let i = 0;
  let list = [];
  const keys = _.keys(originals);
  while (i < keys.length) {
    if (blacklist.indexOf(keys[i]) === -1) {
      list = list.concat(_.flatten(originals[keys[i]]));
    }
    i++;
  }
  return list;
};

utility.getOffset = (el) => {
  const bounding = el.getBoundingClientRect();
  return {
    left: bounding.left + window.scrollX,
    top: bounding.top + window.scrollY,
  };
};

utility.getXsrfToken = () => {
  let cookie;
  const cookies = document.cookie.split(';');
  let token = '';
  let i = 0;
  while (i < cookies.length) {
    cookie = cookies[i].split('=');
    if (cookie[0] === 'XSRF-TOKEN') {
      token = decodeURIComponent(cookie[1]);
    }
    i++;
  }
  return token;
};

utility.makeid = (length = 12) => {
  let text = '';
  let i = 0;
  while (i < length) {
    text += utility.possibleId.charAt(Math.floor(Math.random() * utility.possibleId.length));
    i++;
  }
  return text;
};

utility.parseUri = (path) => {
  const parser = document.createElement('a');
  parser.href = path;
  return parser;
};

utility.slugify = (string) => {
  const trimmed = string.trim();
  return trimmed.replace(/[^a-z0-9-]/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').toLowerCase();
};

utility.stripHtmlComments = (content) => content.replace(/<!--(?!>)[\S\s]*?-->/g, '');

utility.titleFromSlug = (slug) => {
  let i; let word;
  const words = slug.split('-');
  i = 0;
  while (i < words.length) {
    word = words[i];
    words[i] = word.charAt(0).toUpperCase() + word.slice(1);
    i++;
  }
  return words.join(' ');
};

export default utility;
